import clsx from "clsx";
import GradientBorderRadius from "./gradient-border-radius";

export default function FilterToggleButton({
  title,
  selected,
  onClick,
  className,
}: {
  title: string;
  selected?: boolean;
  onClick?: () => void;
  className?: string;
}) {
  return (
    <GradientBorderRadius
      hover="r-100"
      background="default"
      active={selected ? "b-50" : "none"}
      gradient="default-border"
      className="overflow-hidden"
    >
      <div
        className={clsx(
          "flex h-[1.375rem] justify-center items-center gap-[0.3125rem] text-xs font-normal leading-[1.125rem] text-white",
          selected && "bg-switch-button",
          className
        )}
        onClick={onClick}
      >
        {title}
      </div>
    </GradientBorderRadius>
  );
}
